import { useParams } from 'react-router-dom';
import { useGetcomplainAdminQuery } from './complainAdminListSlice';

const ComplainAdminDetail = () => {
    const { id } = useParams();

    const {
        data: complainAdmin
    } = useGetcomplainAdminQuery();

    return (
        <>
            <div className='container-fluid p-4'>
                <div className='row d-flex justify-content-between m-3'>
                    <h4 className='col-5'>
                        Complain Admin
                    </h4>
                    {/* <button className='col-5 col-sm-3 col-md-2 col-lg-1 btn btn-ff9b44 btn-round'
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#compalinWebAction"
                        aria-controls="compalinWebAction"
                    >Action</button> */}
                </div>
                {/* <ComplainAdminAction complainAdmin={complainAdmin}/> */}
                {
                    complainAdmin?.entities?.undefined?.map((e) =>
                        id == e?.id ? (
                            <div key={e?.c_id} className='row card card-body p-3'  >
                                <p className='col-12'><b>Name :</b> <span>{e?.u_name}</span></p>
                                <p className='col-12'><b>Number :</b> <span>{e?.u_number}</span></p>
                                <p className='col-12'><b>Status :</b> <span>{e?.status}</span></p>
                                <p className='col-12'><b>Address :</b> <span>{e?.address}</span></p>

                                <p className='col-12'>
                                    <b>Date :</b>
                                    <span>
                                        {new Date(e?.created_at).toLocaleString("en-IN", {
                                            timeZone: "Asia/Kolkata",
                                            day: "2-digit",
                                            month: "long",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                            hour12: true,
                                        })}
                                    </span>
                                </p>
                                <p className='col-12'><b>Complain :</b> <span>{e?.complain_text}</span></p>
                            </div>
                        ) : null
                    )
                }
            </div>
        </>
    );
}

export default ComplainAdminDetail;
